import { useEffect, useState } from 'react';

import { useMutation, useQuery } from '@tanstack/react-query';
import { newzzService } from 'v2/services/newzz';

const STEP_SIZE = 20;

export const useNewzzList = () => {
  const [itemsPerPage, setItemsPerPage] = useState(STEP_SIZE);

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['newzz'],
    queryFn: () => newzzService.list({ current_page: 1, per_page: itemsPerPage })
  });

  useEffect(() => {
    refetch();
  }, [itemsPerPage, refetch]);

  const clickNewzz = useMutation({
    mutationFn: (id: number) => newzzService.clickNewzz(id)
  });

  const currentPage = data?.pagination?.current_page ?? 1;
  const totalPages = data?.pagination?.total_pages ?? 1;

  return {
    newzz: data?.data ?? [],
    canLoadMore: currentPage < totalPages,
    clickNewzz: (id: number) => clickNewzz.mutateAsync(id),
    loadMore: () => {
      setItemsPerPage(itemsPerPage => itemsPerPage + STEP_SIZE);
    },
    isLoading,
    isFetching,
    error
  };
};

export const useNewzzInfo = (id: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['newzz', 'info', id],
    queryFn: () => newzzService.loadById(id)
  });

  return {
    currentNewzz: data?.data ?? null,
    isLoading,
    error
  };
};
